export enum EReservationServiceGroupID {
	CAR_RENT = 1,
	ADDITIONAL_EQUIPMENT = 2,
	PAYMENTS = 3,
	INSURANCE = 5,
}

export enum EReservationServiceTypeID {
	CAR_RENT = 1,
	ADDITIONAL_EQUIPMENT = 2,
	ADDITIONAL_PAYMENT = 3,
}

export const abroadServiceNames = ['Wyjazd poza granicę kraju', 'Trip outside the country']
